"use client";
// storybook-coverage-ignore: context only, better-auth-ui provider wiring

import { Link, useRouter } from "@/lib/navigation";
import { AuthProvider } from "@repo/auth-ui";

/**
 * better-auth-ui context for the routes that render its components: the
 * `/auth/[authView]` cards and the `/account` settings. It used to sit in the
 * root `Providers`, which shipped better-auth-ui + zod + react-hook-form
 * (~500 KB of script) to every page, including the landing page where nothing
 * consumes it (#714). `Header` reads the session through `authClient` directly
 * and does not need this provider.
 */
export function AuthUiProvider({ children }: Readonly<{ children: React.ReactNode }>) {
  const router = useRouter();

  return (
    <AuthProvider
      Link={Link}
      navigate={router.push}
      // Drop the client router cache on every session change. The header
      // prefetches /dashboard while the visitor is still signed out, so that
      // cached RSC payload is the route's redirect to sign-in; replaying it
      // after sign-up bounced the new user back to sign-in (18 authed E2E
      // specs died on `dashboard-layout` never appearing).
      onSessionChange={() => router.refresh()}
      redirectTo="/dashboard"
      replace={router.replace}
    >
      {children}
    </AuthProvider>
  );
}
